import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import ConfigCard from './ConfigCard';

/**
 * "Behaviour" card. How the header acts while the visitor scrolls or
 * interacts with the page. All copy via the i18n `t` prop with English
 * fallbacks.
 */
const BehaviourCard = ({ value = {}, onChange, theme, t }) => {
    const tr = (key, fallback) => (typeof t === 'function' ? t(key) : fallback);
    const get = (k, fb = false) => (value[k] !== undefined ? value[k] : fb);
    const set = (k) => (v) => onChange && onChange(k, v);

    return (
        <ConfigCard
            title={tr('cfg_nav_behaviour_title', 'Behaviour')}
            description={tr('cfg_nav_behaviour_desc', 'How the header reacts as visitors interact with the page.')}
            theme={theme}
        >
            <Stack spacing={0.5}>
                <FormControlLabel
                    control={
                        <Switch color="success"
                            size="small"
                            checked={!!get('keepMenuVisibleWhileScrolling')}
                            onChange={(e) => set('keepMenuVisibleWhileScrolling')(e.target.checked)}
                        />
                    }
                    label={<Typography variant="body2">{tr('cfg_nav_behaviour_keep_menu_visible', 'Keep menu visible while scrolling')}</Typography>}
                />
            </Stack>
        </ConfigCard>
    );
};

BehaviourCard.propTypes = {
    value:    PropTypes.object,
    onChange: PropTypes.func,
    theme:    PropTypes.string,
    t:        PropTypes.func,
};

export default BehaviourCard;
